export default "__VITE_ASSET__BOKkNpAr__"